import { fetchData, uploadData } from "../utils/api";

const token = localStorage.getItem('Auth');

export const couponService = {
  async getCoupons(page = 1) {
    const response = await fetchData(`/coupon?page=${page}`);
    return response;
  },

  async createCoupon(formData) {
    const response = await fetch("https://api.elza2.store/api/v1/coupon", {
      method: "POST",
      headers: {
        'Authorization': token || '',        
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    return response.json();
  },

  async updateCoupon(id, formData) {
    const response = await fetch(`https://api.elza2.store/api/v1/coupon/${id}`, {
      method: "PUT",
      headers: {
        'Authorization': token || '',
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    return response.json();
  },

  async deleteCoupon(id) {
    const response = await fetch(`https://api.elza2.store/api/v1/coupon/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response.json();
  },
};
